/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {ChangeDetectorRef, Directive, Optional} from '@angular/core';
import {OompaLoompa} from '../../utils/chocolate/oompa-loompa';
import {ClrResponsiveNavigationService} from '../nav/clrResponsiveNavigationService';
import {MainContainerWillyWonka} from './main-container-willy-wonka';
export class NavDetectionOompaLoompa extends OompaLoompa {
private responsiveNavService: ClrResponsiveNavigationService;
/**
 * @param {?} cdr
 * @param {?} willyWonka
 * @param {?} responsiveNavService
 */
constructor(cdr: ChangeDetectorRef,  willyWonka: MainContainerWillyWonka,
                responsiveNavService: ClrResponsiveNavigationService) {
        if (!willyWonka) {
            throw new Error("clr-header should only be used inside of a clr-main-container");
        }
        super(cdr, willyWonka);
        this.responsiveNavService = responsiveNavService;
    }
/**
 * @return {?}
 */
get flavor() {
        return this.responsiveNavService.responsiveNavList.reduce((sum, navLevel) => sum + navLevel, 0);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-header"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: MainContainerWillyWonka, decorators: [{ type: Optional }, ]},
{type: ClrResponsiveNavigationService, },
];
}

function NavDetectionOompaLoompa_tsickle_Closure_declarations() {
/** @type {?} */
NavDetectionOompaLoompa.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NavDetectionOompaLoompa.ctorParameters;
/** @type {?} */
NavDetectionOompaLoompa.prototype.responsiveNavService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
